.container {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: var(--aura-radius-2xl);
  background: color-mix(
    in srgb,
    var(--aura-color-glass-surface) 92%,
    transparent
  );
  border: 1px solid
    color-mix(in srgb, var(--aura-color-global-border-soft) 85%, transparent);
  box-shadow: var(
    --glass-elev-chart-container,
    0 18px 48px rgba(var(--glass-color-black) / var(--glass-opacity-25))
  );
  backdrop-filter: blur(var(--aura-glass-neutral-level3-backdrop-blur));
  -webkit-backdrop-filter: blur(var(--aura-glass-neutral-level3-backdrop-blur));
  overflow: hidden;
  transition:
    transform var(--aura-motion-duration-medium)
      var(--aura-motion-easing-standard),
    box-shadow var(--aura-motion-duration-medium)
      var(--aura-motion-easing-standard);
}

.containerFocused {
  transform: scale(1.02);
  box-shadow: var(
    --glass-elev-chart-container-focused,
    0 28px 72px rgba(var(--glass-color-black) / var(--glass-opacity-30))
  );
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--aura-space-2);
  margin-bottom: var(--aura-space-4);
}

.title {
  margin: 0;
  font-size: var(--aura-font-size-xl);
  font-weight: var(--aura-font-weight-semibold);
  color: var(--aura-color-global-text-primary);
}

.description {
  margin: 0;
  font-size: var(--aura-font-size-base);
  color: color-mix(
    in srgb,
    var(--aura-color-global-text-secondary) 85%,
    transparent
  );
}

.controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--aura-space-4);
  gap: var(--aura-space-3);
}

.tabs {
  flex: 1;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: var(--aura-space-2);
}

.typeButton {
  border: none;
  border-radius: var(--aura-radius-lg);
  padding: var(--aura-space-2) var(--aura-space-3);
  background: transparent;
  color: color-mix(
    in srgb,
    var(--aura-color-global-text-secondary) 75%,
    transparent
  );
  font-size: var(--aura-font-size-sm);
  font-weight: var(--aura-font-weight-medium);
  cursor: pointer;
  transition:
    background var(--aura-motion-duration-fast)
      var(--aura-motion-easing-standard),
    color var(--aura-motion-duration-fast) var(--aura-motion-easing-standard);
}

.typeButton:not(:disabled):hover {
  background: color-mix(
    in srgb,
    var(--aura-color-semantic-primary) 12%,
    transparent
  );
  color: var(--aura-color-global-text-primary);
}

.typeButtonActive {
  background: color-mix(
    in srgb,
    var(--aura-color-semantic-primary) 18%,
    transparent
  );
  color: var(--aura-color-global-text-primary);
  box-shadow: var(
    --glass-elev-chart-type-active,
    0 10px 28px rgba(76, 29, 149, 0.25)
  );
}

.content {
  position: relative;
  width: 100%;
  height: calc(100% - 80px);
  min-height: 0;
  overflow: auto;
}

.contentFocused {
  height: calc(100% - 120px);
}

.footer {
  padding: var(--aura-space-3) var(--aura-space-4);
  font-size: var(--aura-font-size-sm);
  color: color-mix(
    in srgb,
    var(--aura-color-global-text-secondary) 80%,
    transparent
  );
  text-align: center;
}
